import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import pubSub, { EVENTS } from "../../config/pubSub";
import { Snackbar, Alert } from "@mui/material";

const ErrorComponent = () => {
  const [message, setMessage] = useState<any>(null);
  const [open, setOpen] = React.useState(true);
  const { t } = useTranslation();

  const handleClose = () => {
    setOpen(false);
    setMessage(null);
  };

  useEffect(() => {
    pubSub.subscribe(EVENTS.ERROR, (message: any) => {
      setMessage(message);
      if (message) {
        setOpen(true);
      } else {
        setOpen(false);
      }
    });
  }, []);

  return (
    <div data-testid="error-component">
      {message ? (
        <Snackbar
          open={open}
          anchorOrigin={{
            vertical: "top",
            horizontal: "center",
          }}
          autoHideDuration={6000}
          onClose={handleClose}
        >
          <Alert
            severity="error"
            elevation={6}
            variant="filled"
            onClose={handleClose}
          >
            {t(message)}
          </Alert>
        </Snackbar>
      ) : null}
    </div>
  );
};

export default ErrorComponent;
